import axios from 'axios';
import servicios from '../constants/servicios';

const BusquedaController = {
    buscar: async (texto: string) => {
        const url = `${servicios.baseUrl}/${servicios.consultaTexto}`
        const params = {
            texto,
            skip: 0,
            limit: 25
        }
        try {
            return await axios.get(url, { params });
        } catch (err) {
            return err;
        }
    }
}

export default BusquedaController;